import { render, staticRenderFns } from "./PaymentGateway.vue?vue&type=template&id=7c4b60a2"
import script from "./PaymentGateway.vue?vue&type=script&lang=js"
export * from "./PaymentGateway.vue?vue&type=script&lang=js"
import style0 from "./PaymentGateway.vue?vue&type=style&index=0&id=7c4b60a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports